import React from 'react'

interface AssistiveTextProps {
  errorMessage: string;
  helperText: string;
  disabled: boolean;
  className?: string;
}

const AssistiveText = ({
  errorMessage,
  helperText,
  disabled,
  className = ''
}: AssistiveTextProps) => {
  const showErrorMessage = errorMessage?.trim() !== ''
  const showHelper = helperText?.trim() !== ''

  const text = showErrorMessage ? errorMessage : helperText
  if (!showErrorMessage && !showHelper) return null

  return (
    <p
      className={`absolute text-xs left-3 pt-0.5 font-titillium ${
        showErrorMessage
          ? 'text-kwota-alert-400'
          : disabled
            ? 'text-kwota-neutral-400'
            : 'text-kwota-neutral-500'
      } ${className}`}
    >
      {text}
    </p>
  )
}

export default AssistiveText
